import { Box } from '@mui/material'
import { CartLoader } from 'components/Loader/CartLoader'
import React, { PropsWithChildren, Suspense } from 'react'

type Props = {}

export const SuspenseWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            width: '100%',
            height: '100dvh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CartLoader />
        </Box>
      }
    >
      {children}
    </Suspense>
  )
}
